import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { UserInfoService } from 'src/app/services/user-info.service';
import { DataService } from 'src/app/services/data-api.service';
import { ResetPasswordRequest, ResetPasswordResponse, ResetPasswordViewModel, UserNotificationViewModel } from 'src/app/models/viewmodels';
import { UserNotificationService } from 'src/app/services/user-notification.service';
import { ValidatorsHelper } from '../../util/validators-helper';
import { ErrorMessagesComponent } from '../../util/error-messages/error-messages.component';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationTypeEnum } from 'src/app/models/config-view-models';
import { environment } from 'src/environments/environment';
import { FileService } from 'src/app/services/file.service';
import { TogglePasswordDirective } from 'src/app/directives/toggle-password.directive';

@Component({
  standalone:true,
  selector: 'app-user-reset-password',
  templateUrl: './user-reset-password.component.html',
  styleUrls: ['./user-reset-password.component.scss'],
  imports: [IonicModule ,FormsModule,CommonModule,RouterModule,ReactiveFormsModule,ErrorMessagesComponent, TogglePasswordDirective]

})
export class UserResetPasswordComponent  implements OnInit {

  userResetPasswordForm: FormGroup = new FormGroup({});
  logoImagePath: string = '';
  token: string = '';
  userId: number = 0;
  resetPasswordViewModel: Partial<ResetPasswordViewModel> = {};
  isRequiredField = ValidatorsHelper.isRequired;

  //setPassword: boolean = false;

  isNotEqualTo = ValidatorsHelper.isNotEqualTo;
  passwordMatchValidator = ValidatorsHelper.passwordMatchValidator;

  validationParameters = {
    'password': [
    {type: 'required', message: "Password field is required"},
    {type: 'pattern', message: "Password must contain, at least 8 characters and, one uppercase,lowercase, number and special character. Ex. Password1!"},
    {type: 'notEqualTo', message: "Cannot use example password Password1!"},

    ],
    'reenterPassword': [
    {type: 'required', message: "Password field is required"},
    {type: 'passwordMismatch', message: "Passwords don't match"},
  ]};

  constructor(private fb: FormBuilder,private userInfoService: UserInfoService,private dataService: DataService,private activatedRoute: ActivatedRoute,
    private userNotificationService: NotificationService, private fileService: FileService) {

  
  }

  onClickTermsOfUse() {
      this.fileService.handleFileStreamResponse({
        url: environment.apiUrl + 'api/file/GetCustomerTermsOfUsePdf',
        download: true,
        openInNewTab: true,
        fileName: 'CustomerTermsOfUse'
      });
  }
    
initData(){
  this.userResetPasswordForm =  this.fb.group(
      {
        password: ['', [
          Validators.required,
          Validators.pattern('^(?=.*[A-Z])(?=.*[a-z])(?=.*\\d)(?=.*[^A-Za-z\\d])[A-Za-z\\d\\S]{8,}$'),
          this.isNotEqualTo('Password1!'),  // Custom "not equals" validator

        ]],
        reenterPassword: ['', [Validators.required],[]],
        agreedToCustomerTermsOfUse: [false, [Validators.requiredTrue]],
     },
          {
        validator: this.passwordMatchValidator('password', 'reenterPassword')
      });
     
}  
async ngOnInit() {


    //this.logoImagePath = "/assets/images/QuotifyLogoImage.png"
    try {
      let isEngineerUrl = window.location.href.toLowerCase().includes('specifymanagerpro.com') || window.location.href.toLowerCase().includes('localhost:8123');
      if (isEngineerUrl) {
        this.logoImagePath = '/assets/images/SpecifyManagerLogo.png';
      } else {
        this.logoImagePath = "/assets/images/QuotifyLogoImage.png"
      }
    } catch (error) {
      console.error('user-login', 'ngOnInit', 'error getting logo image path', error);
    }
    
    this.initData();

    this.activatedRoute.queryParams.subscribe(params => {
      this.token = params['token'];
      this.userId = params['userId'];

      this.dataService.getResetPasswordViewModel(this.userId).subscribe({
        next : (response: ResetPasswordViewModel) => {
          this.resetPasswordViewModel = response;
          if(this.resetPasswordViewModel.signedCustomerTermsOfUse){
            this.userResetPasswordForm.get('agreedToCustomerTermsOfUse')?.disable();
     }
        },
        error: (err) => {
          this.userNotificationService.PresentTypedToast("Error fetching reset password view model. Check Console", NotificationTypeEnum.Error);
          console.error('Error fetching reset password view model', err);
        }

      })

    });
   

  }

  onSubmitForm(){
    this.userResetPasswordForm.markAllAsTouched();
    if(this.userResetPasswordForm.valid){
        
        var password:string = this.userResetPasswordForm.get('password').value;
        var reEnterPassword:string = this.userResetPasswordForm.get('reenterPassword').value;
        var agreedToCustomerTermsOfUse:boolean = this.userResetPasswordForm.get('agreedToCustomerTermsOfUse')?.value ?? false;
        const resetPasswordRequest: ResetPasswordRequest = {password: password, token: this.token,reEnterPassword: reEnterPassword, userId : this.userId, agreedToCustomerTermsOfUse: agreedToCustomerTermsOfUse};
        this.dataService.resetPassword(resetPasswordRequest).subscribe(
        
          (res: ResetPasswordResponse) =>{
   
           if(res.success){
            var action = !this.resetPasswordViewModel.hasPassword ? 'Set' : 'Reset';
             this.userNotificationService.PresentTypedToast(`${action} Password Sucessful`, NotificationTypeEnum.Success,6000,()=> {
              window.location.href = '/user/user-login'

             });
   
   
           }else{
             this.userNotificationService.PresentTypedToast("API Failed on Reset Password. Check Console", NotificationTypeEnum.Error);
             console.error('API Failed on Reset Password', res);
           }          
          },
         )
      
      

    }
  }



}
